import React from "react";
import "./Reels.css";

function Reels(){
    return <div className="reels">Reels</div>;
}
export default Reels;